import userService from "@/services/userService";
import router from "../../router/index";
var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
  stringify: function(cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function(jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

export const state = {
  ip: "",
  loading: false,
  deactivateLoading: false,
  updateLoading: false,
  shouldLogOut: false,
  newImage: null,
  firstName: null,
  lastName: null,
  searchUserData: null,
  phone: null,
  email: null,
  tmpPwd: null,
  encPwd: null,
  encEmail: null,
  code: null,
  modalState: false,
  companyName:null,
  userData:null,
  qr:null,
  userVisits:[],
  userId: null,
  otpRequired : false,
  userIsVerified : false,
};

export const actions = {
  setTmpPwdFlag({ commit }, params) {
    commit("setIp", Math.floor(Math.random(1, 9) * 1000000));
    return new Promise(() => {
      userService
        .updateTmpPwdFlag(params)
        .then((data) => {
          if (data.data === 1) {
            commit("setTmpPwd", 0);
          }
        })
        .catch((err) => {
          console.log(err.data.message);
        });
    });
  },
  getUserIpAction({ commit }) {
    return new Promise(() => {
      userService
        .getIp()
        .then((data) => {
          const key = localStorage.getItem("serverId");
          const encryptedIp = CryptoJS.AES.encrypt(
            JSON.stringify(data.data.ip),
            key,
            { format: CryptoJSAesJson }
          ).toString();
          commit("setIp", btoa(encryptedIp));
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  updateUserNameAction({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .updateUserName(params)
        .then((data) => {
          this._vm.$toast.success("User Name Updated");
          dispatch("saveUserFirstName", params.first_name);
          dispatch("saveUserLastName", params.last_name);
          commit("setUserQr", data.data);
          commit("setLoading", false);
          commit("setFormErrors", []);
          commit("setModalState", true);
        })
        .catch((err) => {
          this._vm.$toast.error(Object.values(err.data.errors).join("\r\n"));
          commit("setLoading", false);
          commit("grid/setLoadong", false, { root: true });
          commit("setModalState", false);
        });
    });
  },
  editCompanyName({ commit }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .editCompanyName(params)
        .then((data) => {
          this._vm.$toast.success("Company Name Updated");
          commit("setUserQr", data.data);
          commit("setLoading", false);
          commit("setFormErrors", []);
          commit("setModalState", true);
          commit("setCompanyName", params.company);
        })
        .catch((err) => {
          this._vm.$toast.error(Object.values(err.data.errors).join("\r\n"));
          commit("setLoading", false);
          commit("grid/setLoadong", false, { root: true });
          commit("setModalState", false);
        });
    });
  },
  updateUserImageAction({ commit }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .updateUserImage(params)
        .then((data) => {
          this._vm.$toast.success(data.message);
          commit("setLoading", false);
          commit("setUserQr", data.qr_url);
          commit("setUserNewImage", data.imgName);
          commit("setShowEditImageModal", true);
          commit("setFormErrors", []);
        })
        .catch((err) => {
          this._vm.$toast.error(err.data.message);
          //commit("setFormErrors", err.data.errors);
          commit("setLoading", false);
          commit("setShowEditImageModal", false);
          commit("grid/setLoadong", false, { root: true });
        });
    });
  },
  updateImagePreRegAction({ commit }, params) {
    commit("setUserNewImage", params);
  },
  changeUserEmailAction({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .updateUserEmail(params)
        .then((data) => {
          this._vm.$toast.success("Email Updated");
          commit("setUserQr", data.data);
          dispatch("saveUserEmail", params.new_email);
          commit("setLoading", false);
          commit("setFormErrors", []);
          commit("setModalState", true);
          setTimeout(() => {
            router.push("/logout");
          }, 500);
        })
        .catch((err) => {
          commit("setFormErrors", err.data.errors);
          commit("setLoading", false);
          commit("grid/setLoadong", false, { root: true });
          commit("setModalState", false);
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  changeUserPhoneAction({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .updateUserPhone(params)
        .then((data) => {
          dispatch("saveUserPhone", params.phone);
          commit("setLoading", false);
          commit("setUserQr", data.data);
          commit("setFormErrors", []);
          commit("setModalState", true);
          setTimeout(() => {
            router.push("/logout");
          }, 500);
        })
        .catch((err) => {
          commit("setLoading", false);
          commit("grid/setLoadong", false, { root: true });
          commit("setModalState", false);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.data);
        });
    });
  },
  changeUserTimeZoneAction({ commit, dispatch }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .updateUserTimeZone(params)
        .then((data) => {
          this._vm.$toast.success(data.message);
          dispatch("saveUserTimeZone", params.timezone.timezones[0]);
          commit("setLoading", false);
          commit("setShowEditTimeZoneModal", false);
          commit("setFormErrors", []);
        })
        .catch((err) => {
          this._vm.$toast.error(err.data.message);
          //commit("setFormErrors", err.data.errors);
          commit("setLoading", false);
          commit("setShowEditTimeZoneModal", true);
          commit("grid/setLoadong", false, { root: true });
        });
    });
  },
  changeUserPasswordAction({ commit }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .updateUserPassword(params)
        .then((data) => {
          this._vm.$toast.success(data.message);
          commit("setLoading", false);
          commit("setTmpPwd", 0);
          commit("setFormErrors", []);
          commit("setModalState", true);
          setTimeout(() => {
            router.push("/logout");
          }, 500);
        })
        .catch((err) => {
          this._vm.$toast.error(err.data.message);
          commit("setFormErrors", err.data.errors);
          commit("setLoading", false);
          commit("grid/setLoadong", false, { root: true });
          commit("setModalState", false);
        });
    });
  },
  deactivateAccount({ commit }, params) {
    commit("setDeactivateLoading", true);
    return new Promise((resolve, reject) => {
      userService
        .deactivateUserAccount(params)
        .then((data) => {
          resolve(data);
          commit("setDeactivateLoading", false);
          commit("setFormErrors", []);
          router.push("/logout");
          this._vm.$toast.success(data.message);
        })
        .catch((err) => {
          reject(err)
          commit("setFormErrors", err.data.errors);
          commit("setDeactivateLoading", false);
            commit("grid/setLoadong", false, { root: true });
          // this._vm.$toast.error(err.data.message);
        });
    });
  },

  updateDefaultEntity({ commit }, params) {
    commit("setUpdateLoading", true);
    return new Promise(() => {
      userService
        .updateDefaultEntity(params)
        .then((data) => {
          commit("setUpdateLoading", false);
          this._vm.$toast.success(data.message);
        })
        .catch((err) => {
          commit("setUpdateLoading", false);
          console.log('err', err.data.message);
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  
  acceptInvitationAction({ commit }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
        .acceptInvitation(params)
        .then((data) => {
          commit("entities/setPendingInvitation", {}, { root: true });
          this._vm.$toast.success(data.message);
          commit("setLoading", false);
          router.replace("/");
        })
        .catch((err) => {
          commit("entities/setPendingInvitation", {}, { root: true });
          this._vm.$toast.error(err.data.message);
          commit("setLoading", false);
        });
    });
  },
  fetchUserVisits({ commit }, id) {
    commit("setLoading", true);
    commit("setUserVisits", {});
    return new Promise(() => {
      userService
        .getUserVisits(id)
        .then((data) => {
          commit("setLoading", false);
          commit("setUserVisits", data.data);
        })
        .catch((err) => {
          commit("setLoading", false);
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchUserVisitsByServer({ commit }, payload) {
    commit("setLoading", true);
    // commit("setUserVisits", {});
    return new Promise((resolve, reject) => {
      userService
        .getUserVisitsByServer(payload)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
          // commit("setUserVisits", data.data);
        })
        .catch((err) => {
          reject(err);
          commit("setLoading", false);
          this._vm.$toast.error(err.data.message);
        });
    });
  },
  validateUserPassword({ commit }, payload) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      userService
        .validateUserPassword(payload)
        .then((data) => {
          resolve(data);
          commit("setLoading", false);
        })
        .catch((err) => {
          reject(err);
          // this._vm.$toast.error(err.data.message);
          commit("setLoading", false);
        });
    });
  },


  setDisplayCreateCompanyModal({ commit }, payload) {
    commit("setShowCreateCompanyModal", payload);
  },
  saveUserNewImage({ commit }, payload) {
    commit("setUserNewImage", payload);
  },
  saveUserFirstName({ commit }, payload) {
    commit("setUserFirstName", payload);
  },
  saveUserLastName({ commit }, payload) {
    commit("setUserLastName", payload);
  },
  saveUserPhone({ commit }, payload) {
    commit("setUserPhone", payload);
  },
  saveUserEmail({ commit }, payload) {
    commit("setUserEmail", payload);
  },
  saveUserCode({ commit }, payload) {
    commit("setCode", payload);
  },
  saveTmpPwdStatus({ commit }, payload) {
    commit("setTmpPwd", payload);
  },
  saveUserTimeZone({ commit }, payload) {
    commit("setUserTimeZone", payload);
  },
  saveUserQr({ commit }, payload) {
    commit("setUserQr", payload);
  },
  resetState({ commit }) {
    commit("setLoading", false);
    commit("setModalState", false);
  },
  getUserByEmailOrPhone( { commit }, params) {
    commit("setLoading", true);
    return new Promise(() => {
      userService
          .getUser(params)
          .then((data) => {
            commit("setSearchUser", data.data);
            this._vm.$toast.success("User Fetched Successfully");
            commit("setLoading", false);
          })
          .catch((err) => {
            commit("setSearchUser", null);
            this._vm.$toast.error(err.data.message);
            commit("setLoading", false);
          });
    });
  },
  resetUserPassword( { commit }, payload) {
    commit("setLoading", true);
    const key = localStorage.getItem("serverId");
    const encryptedPassword = CryptoJS.AES.encrypt(
        JSON.stringify(payload.password),
        key,
        { format: CryptoJSAesJson }
    ).toString();
    return new Promise((resolve) => {
      userService
          .resetUserPassword(payload.id, btoa(encryptedPassword))
          .then((data) => {
            resolve(data);
            commit("setSearchUser", null);
            this._vm.$toast.success("User Account Reset Successfully");
            commit("setLoading", false);
          })
          .catch((err) => {
            commit("setSearchUser", null);
            this._vm.$toast.error(err.data.message);
            commit("setLoading", false);
          });
    });
  },
  clearSearchUser({ commit }) {
    commit("setSearchUser", null);
  },
};

export const mutations = {
  setUserData(state, payload) {
    state.userData = payload;
  },
  setUserOtpRequired(state, payload) {
    state.otpRequired = payload;
  },
  setUserIsVerified(state, payload) {
    state.userIsVerified = payload;
  },
  setUserDataImg(state, payload) {
    state.userData.image = payload;
  },
  setSearchUser(state, payload) {
    state.searchUserData = payload;
  },
  setUserVisits(state, payload) {
    state.userVisits = payload;
  },
  setEncEmail(state, payload) {
    state.encEmail = payload;
  },
  setCode(state, payload) {
    state.code = payload;
  },
  setCompanyName(state, payload) {
    state.companyName = payload;
  },
  setEncPwd(state, payload) {
    state.encPwd = payload;
  },
  setTmpPwd(state, payload) {
    state.tmpPwd = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setDeactivateLoading(state, payload) {
    state.deactivateLoading = payload;
  },
  setUpdateLoading(state, payload) {
    state.updateLoading = payload;
  },
  setIp(state, payload) {
    state.ip = payload;
  },
  setUserNewImage(state, payload) {
    state.newImage = payload;
  },
  clearSearchUser({ commit }) {
    commit("setSearchUser", null);
  },
  setUserFirstName(state, payload) {
    state.firstName = payload;
  },
  setUserLastName(state, payload) {
    state.lastName = payload;
  },
  setUserPhone(state, payload) {
    state.phone = payload;
  },
  setUserEmail(state, payload) {
    state.email = payload;
  },
  setUserTimeZone(state, payload) {
    state.timeZone = payload;
  },
  setUserQr(state, payload) {
    state.qr = payload;
  },
  setFormErrors(state, payload) {
    state.formErrors = payload;
  },
  setModalState(state, payload) {
    state.modalState = payload;
  },
};

export const getters = {
  getUserData(state) {
    return state.userData;
  },
  getUserOtpRequired(state) {
    return state.otpRequired;
  },
  getUserIsVerified(state) {
    return state.userIsVerified;
  },
  getSearchUser(state) {
    return state.searchUserData;
  },
  getUserVisits(state) {
    return state.userVisits;
  },
  getCompanyName(state) {
    return state.companyName;
  },
  getEncEmail(state) {
    let decryptedEmail = null;
    if (
      state.encEmail !== null &&
      state.encEmail !== undefined &&
      state.encEmail !== ""
    ) {
      const key = process.env.VUE_APP_PASSPORT_KEY;
      decryptedEmail = CryptoJS.AES.decrypt(atob(state.encEmail), key, {
        format: CryptoJSAesJson,
      }).toString(CryptoJS.enc.Utf8);
    }
    return decryptedEmail;
  },
  getEncPwd(state) {
    let decryptedPwd = null;
    if (
      state.encPwd !== null &&
      state.encPwd !== undefined &&
      state.encPwd !== ""
    ) {
      const key = process.env.VUE_APP_PASSPORT_KEY;
      decryptedPwd = CryptoJS.AES.decrypt(atob(state.encPwd), key, {
        format: CryptoJSAesJson,
      }).toString(CryptoJS.enc.Utf8);
    }
    return decryptedPwd;
  },
  getCode(state) {
    return state.code;
  },
  getTmpPwd(state) {
    return state.tmpPwd;
  },
  getLoading(state) {
    return state.loading;
  },
  getDeactivateLoading(state) {
    return state.deactivateLoading;
  },
  getUpdateLoading(state) {
    return state.updateLoading;
  },
  getIp(state) {
    return state.ip;
  },
  getUserNewImage(state) {
    return state.newImage;
  },
  getUserFirstName(state) {
    return state.firstName;
  },
  getUserLastName(state) {
    return state.lastName;
  },
  getUserPhone(state) {
    return state.phone;
  },
  getUserEmail(state) {
    return state.email;
  },
  getUserTimeZone(state) {
    return state.timeZone;
  },
  getUserQr(state) {
    return state.qr;
  },
  getFormErrors(state) {
    return state.formErrors;
  },
  getModalState(state) {
    return state.modalState;
  },
};
